var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"caseProgress"},[_vm._v("案件进度")])
}
var staticRenderFns = []

export { render, staticRenderFns }